import Graph from "./section/Graph";
import Faq from "../Home/Section/Faq";
import { Link } from "react-router-dom";
import ZeussToken from "../../../Contract/zeussToken.json";
const Staking = () => {
  return (
    <>
      <div className="topbar">
        <h4>
          $TRIBE Contract Address{" "}
          <Link
            target="_blank"
            to={`https://etherscan.io/token/${ZeussToken.address}`}
          >
            {ZeussToken.address}
          </Link>
        </h4>
      </div>
      <div className="wrapper">
        <div className="pageback">
          <section className="Terms Contact">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="heading text-center">
                    <h4>Welcome to $TRIBEStaking</h4>
                    <p>
                      The distribution of $TRIBE token rewards will occur on the
                      Ethereum blockchain. The reward rate and distribution
                      period are currently under development and will be
                      announced soon. Rewards will be claimable once the
                      claiming feature is activated on the TRIBE platform.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Graph />
          <Faq />
        </div>
      </div>
    </>
  );
};
export default Staking;
